export default "__VITE_ASSET__D$ooXJ9c__";